import PropTypes from 'prop-types';
import { cn } from 'Utils/cn';

export default function SnackbarMedia({ className, children }) {
    return (
        <div className={cn('shrink-0 w-9 text-center [&_img]:w-full [&_img]:h-auto [&_img]:block', className)}>
            {children}
        </div>
    );
}

SnackbarMedia.propTypes = {
    className: PropTypes.string,
    children: PropTypes.node,
};
